<template>
  <div class="c-upcoming-deadlines-block text-center p-2">
    <div class="c-upcoming-deadlines-block__bg p-3">
      <h5 class="c-upcoming-deadlines-block__date">
        {{ date }}
      </h5>

      <div class="c-upcoming-deadlines-block__text">
        <span v-html="text"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

@Component
export default class UpcomingDeadlineBlock extends Vue {
  @Prop()
  date!: string;

  @Prop()
  text!: string;
}
</script>

<style lang="scss" scoped>
.c-upcoming-deadlines-block {
  &__bg {
    background-color: #585D62;
  }

  &__date {
    color: #fff;
    border-bottom: 1px solid #ccc;
    padding-bottom: 0.75rem;
  }

  &__text {
  }
}
</style>
